import { SWC_PROMISE } from '@/data/promise';
import { TIERS } from '@/data/tiers';
import TierCard from '@/components/pricing/TierCard';

interface CompareRow {
  label: string;
  garage: string;
  restorer: string;
  pro_shop: string;
}

const COMPARE: readonly CompareRow[] = [
  { label: 'Inventory access', garage: 'Full', restorer: 'Full', pro_shop: 'Full' },
  { label: 'Vehicle profiles', garage: '3', restorer: 'Unlimited', pro_shop: 'Unlimited' },
  { label: 'Active quotes / month', garage: '5', restorer: 'Unlimited', pro_shop: 'Unlimited' },
  { label: 'VIN scanner', garage: 'Basic', restorer: 'Full', pro_shop: 'Full' },
  { label: 'Branded PDF exports', garage: '—', restorer: 'Yes', pro_shop: 'Co-branded' },
  { label: 'AI new-arrival alerts', garage: '—', restorer: 'Yes', pro_shop: 'Yes' },
  { label: '"Source It" requests', garage: '—', restorer: 'Included', pro_shop: 'Priority' },
  { label: 'User seats', garage: '1', restorer: '1', pro_shop: 'Up to 5' },
  { label: 'Tech line', garage: 'Standard', restorer: 'Priority', pro_shop: 'Direct to founder' },
  { label: 'Monthly market intel brief', garage: '—', restorer: '—', pro_shop: 'Yes' },
];

export default function Pricing() {
  return (
    <div className="app">
      <div className="main">
        <div className="eyebrow">Pricing · All Plans Include the SWC Promise</div>
        <h1 className="h-display">Pick the tier that matches your build.</h1>
        <p className="lead" style={{ marginBottom: 36 }}>
          Three plans, cancel anytime, no hidden fees. Every plan ships with the full SWC Promise —
          authentication on every part, no-questions returns, a real tech line, and free shipping
          on anything under 100 lbs.
        </p>

        <div className="tiers" style={{ marginBottom: 48 }}>
          {TIERS.map((t) => (
            <TierCard key={t.id} tier={t} />
          ))}
        </div>

        <div className="card-elev" style={{ marginBottom: 48, padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '20px 28px', borderBottom: '1px solid var(--line-2)' }}>
            <div className="eyebrow" style={{ marginBottom: 4 }}>Compare</div>
            <h2 className="h-section" style={{ margin: 0 }}>Feature-by-feature</h2>
          </div>
          <div className="table-scroll">
          <table className="compare-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: 'var(--bg-2)' }}>
              <tr>
                <th style={thStyle}>Feature</th>
                <th style={thStyle}>Garage</th>
                <th style={{ ...thStyle, color: 'var(--cream)' }}>Restorer</th>
                <th style={thStyle}>Pro Shop</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE.map((row) => (
                <tr key={row.label}>
                  <td style={tdStyle}>{row.label}</td>
                  <td style={tdNumStyle}>{row.garage}</td>
                  <td style={{ ...tdNumStyle, color: 'var(--cream)' }}>{row.restorer}</td>
                  <td style={tdNumStyle}>{row.pro_shop}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>

        <div className="card-elev" style={{ marginBottom: 48 }}>
          <div className="eyebrow">The SWC Promise · Included in every plan</div>
          <h2 className="h-section">What you get on every part, every order.</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 18, marginTop: 16 }}>
            {SWC_PROMISE.map((p) => (
              <div key={p.title} style={{ background: 'var(--bg)', border: '1px solid var(--line)', padding: 18 }}>
                <div className="h-card">{p.title}</div>
                <p style={{ fontSize: 13, color: 'var(--text-dim)', lineHeight: 1.55 }}>{p.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '14px 16px',
  fontFamily: 'var(--mono)',
  fontSize: 10,
  letterSpacing: '0.18em',
  color: 'var(--gold)',
  textTransform: 'uppercase',
  borderBottom: '1px solid var(--line-2)',
};

const tdStyle: React.CSSProperties = {
  padding: '12px 16px',
  borderBottom: '1px solid var(--line)',
  fontSize: 13,
  color: 'var(--text)',
};

const tdNumStyle: React.CSSProperties = {
  ...tdStyle,
  fontFamily: 'var(--mono)',
  color: 'var(--text-dim)',
};
